import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import Popover from "@mui/material/Popover"

const PopoverStyled = styled(Popover)`
  /*& .MuiPopover-paper {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.15);
    border: 1px solid rgba(206, 206, 206, 0.5);
    margin : 5px 0px 0px;
    bordeRadius: 6px;
  }*/
  & .MuiPopover-paper {
    border: 0;
    background: transparent;
    box-shadow: none;
    margin : 5px 0px 0px;
    overflow: unset;
  }
`

const MyPopover = ({
  anchorEl,
  anchorOrigin,
  transformOrigin,
  isDrawerOpen,
  handleClose,
  className,
  margin,
  children,
}) => {
  return (
    <PopoverStyled
      anchorEl={anchorEl}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={isDrawerOpen}
      onClose={handleClose}
      disablePortal={true}
      className={className}
      margin={margin}
    >
      {children}
    </PopoverStyled>
  )
}

MyPopover.propTypes = {
  anchorOrigin: PropTypes.object.isRequired,
  transformOrigin: PropTypes.object,
  isDrawerOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
  children: PropTypes.node.isRequired,
}

export default MyPopover
